// Build identifiers injected by Vite (see vite.config.ts `define`).
// Available three ways:
//   - in the dashboard footer (LastRefreshed component)
//   - as window.__APP_VERSION__ in the browser console
//   - as /version.json next to the bundle (written by the CI workflow)
export const APP_VERSION = __APP_VERSION__;
export const APP_REF = __APP_REF__;
export const APP_BUILD_TIME = __APP_BUILD_TIME__;

if (typeof window !== 'undefined') {
  const w = window as unknown as Record<string, unknown>;
  w.__APP_VERSION__ = APP_VERSION;
  w.__APP_REF__ = APP_REF;
  w.__APP_BUILD_TIME__ = APP_BUILD_TIME;
}
